<template>
	<li v-if="notifItem.type === 'follow'" class="activity-item">
		<div>
			<ion-icon name="radio-button-off" @click.stop="markAsRead" title="Mark as read"></ion-icon>
		</div>
		<div class="notif-profile-picture" v-if="Object.keys(user).length > 0">
			<img v-if="user.photoURL" :src="user.photoURL" alt="Profile picture" @click="goToUser" />
			<no-user-image
				v-else
				:firstName="user.firstName"
				:lastName="user.lastName"
				:fontSize="13"
				:height="'35px'"
				:width="'35px'"
				@click.prevent="goToUser"
			></no-user-image>
		</div>
		<div class="notif-body">
			<p class="notif-date">{{notifItem.dateCreated | formatDate}}</p>
			<p class="notif-title">You have a new follower</p>
			<p class="notif-message">
				<span :title="`View ${user.firstName}'s profile`">
					<a @click.prevent="goToUser">@{{user.username}}</a>
				</span>
				<span class="notif-message">&nbsp;followed you</span>
			</p>
		</div>
		<div class="notif-action">
			<user-follow-button v-if="Object.keys(user).length > 0" :user="user"></user-follow-button>
		</div>
	</li>
	<li v-else-if="notifItem.type === 'group-created'" class="groups-item" @click="openGroupsModal">
		<div>
			<ion-icon name="radio-button-off" @click.stop="markAsRead" title="Mark as read"></ion-icon>
		</div>
		<div class="notif-body">
			<p class="notif-date">{{notifItem.dateCreated | formatDate}}</p>
			<p class="notif-title">
				<span class="notif-user" :title="`View ${user.firstName}'s profile`">
					<a @click.prevent="goToUser">@{{user.username}}</a>
				</span>
				added you to a group
			</p>
			<p class="notif-message">
				<user-images-list v-if="typeof(notifItem.members) === 'object'" :users="groupUsers"></user-images-list>
				<span v-else class="group-name">
					<span v-if="group !== undefined && Object.keys(group).length > 0">{{group.groupName}}</span>
				</span>
				<span
					v-if="group !== undefined && Object.keys(group).length > 0"
					class="group-count"
				>{{group.members.length}} active members</span>
			</p>
		</div>
		<div class="notif-action" v-if="notifItem.group && userIsInGroup">
			<!-- <ion-icon
		name="arrow-round-forward"
		@click="openGroupsModal"
		title="View group">
			</ion-icon>-->
		</div>
		<div v-else-if="!notifItem.group">
			<span class="stackng-note">No group id</span>
		</div>
		<div v-else-if="!userIsInGroup">
			<span class="stackng-note">You left/Group was deleted</span>
		</div>
	</li>
	<li v-else-if="notifItem.type === 'group-deleted'" class="groups-item" style="cursor:not-allowed">
		<div>
			<ion-icon name="radio-button-off" @click.stop="markAsRead" title="Mark as read"></ion-icon>
		</div>
		<div class="notif-body">
			<p class="notif-date">{{notifItem.dateCreated | formatDate}}</p>
			<p class="notif-title">
				<span class="notif-user" :title="`View ${user.firstName}'s profile`">
					<a @click.prevent="goToUser">@{{user.username}}</a>
				</span>
				deleted this group
			</p>
			<p class="notif-message">
				<user-images-list :users="groupUsers"></user-images-list>
			</p>
		</div>
		<div class="notif-action"></div>
	</li>
	<li v-else-if="notifItem.type === 'welcome'" class="activity-item" @click="goToAbout">
		<div>
			<ion-icon name="radio-button-off" @click.stop="markAsRead" title="Mark as read"></ion-icon>
		</div>
		<div class="notif-profile-picture">&#x1F38A;</div>
		<div class="notif-body">
			<p class="notif-date">{{notifItem.dateCreated | formatDate}}</p>
			<p class="notif-title">Welcome to StackNG {{user.firstName}}!</p>
			<p class="notif-message">
				<a @click.prevent="goToAbout">See what StackNG has to offer</a>
			</p>
		</div>
	</li>
	<li
		v-else-if="notifItem.type.includes('unlocked')"
		class="unlock-item"
		@click="notifItem.type.includes('groups') ? showAllGroups : goToUser"
	>
		<div>
			<ion-icon name="radio-button-off" @click.stop="markAsRead" title="Mark as read"></ion-icon>
		</div>
		<div class="notif-profile-picture">
			<span v-if="notifItem.type === 'stack-unlocked'">
				<ion-icon name="logo-buffer" @click.stop="goToUser"></ion-icon>
			</span>
			<span v-else-if="notifItem.type === 'groups-unlocked'">
				<ion-icon name="ios-contacts" @click="showAllGroups"></ion-icon>
			</span>
		</div>
		<div class="notif-body">
			<p class="notif-date">{{notifItem.dateCreated | formatDate}}</p>
			<p class="notif-title" v-if="notifItem.type === 'stack-unlocked'">You have unlocked STACK!</p>
			<p class="notif-title" v-else-if="notifItem.type === 'groups-unlocked'">You have unlocked GROUPS!</p>
		</div>
		<div class="notif-action">
			<p class="notif-message" v-if="notifItem.type === 'stack-unlocked'">
				<a @click.prevent="goToUser">Go to Stack</a>
			</p>
			<p class="notif-message" v-else-if="notifItem.type === 'groups-unlocked'">
				<a @click.prevent="showAllGroups">View groups</a>
			</p>
		</div>
	</li>
	<li
		v-else-if="notifItem.type === 'group-admin-change'"
		class="groups-item"
		@click="openGroupsModal"
	>
		<div>
			<ion-icon name="radio-button-off" @click.stop="markAsRead" title="Mark as read"></ion-icon>
		</div>
		<div class="notif-body">
			<p class="notif-date">{{notifItem.dateCreated | formatDate}}</p>
			<p class="notif-title">
				<span class="notif-user" :title="`View ${user.firstName}'s profile`">
					<a @click.prevent="goToUser">@{{user.username}}</a>
				</span>
				left, you are the new admin!
			</p>
			<p class="notif-message">
				<user-images-list v-if="typeof(notifItem.members) === 'object'" :users="groupUsers"></user-images-list>
				<span v-else class="group-name">
					<span v-if="group !== undefined && Object.keys(group).length > 0">
						<!-- &#x1F468; -->
						{{group.groupName}}
					</span>
				</span>
				<span
					v-if="group !== undefined && Object.keys(group).length > 0"
					class="group-count"
				>{{group.members.length}} active members</span>
			</p>
		</div>
		<div class="notif-action" v-if="notifItem.group && userIsInGroup">
			<!-- <ion-icon
			name="arrow-round-forward"
			@click="openGroupsModal"
			title="View group">
			</ion-icon>-->
		</div>
		<div v-else-if="!notifItem.group">
			<span class="stackng-note">No group id</span>
		</div>
		<div v-else-if="!userIsInGroup">
			<span class="stackng-note">You left/Group was deleted</span>
		</div>
		<!-- <p>Admin change</p> -->
	</li>
</template>

<script>
import UserImagesList from "../users/userLists/UserImagesList";
import UserFollowButton from "../users/userView/UserFollowButton.vue";
import NoUserImage from "../errors/NoUserImage.vue";
import { notificationsMixin } from "../../mixins/notificationsMixin";
import { groupsMixin } from "../../mixins/groupsMixin";
import { getUser, getUsers } from "../../api/users";
import { getGroup } from "../../api/groups";

export default {
	mixins: [notificationsMixin, groupsMixin],
	data() {
		return {
			user: {},
			groupUsers: [],
			group: {},
			userIsInGroup: null
		};
	},
	props: {
		notifItem: {
			type: Object
		}
	},
	components: {
		UserImagesList,
		UserFollowButton,
		NoUserImage
	},
	async beforeMount() {
		if (this.notifItem.type.includes("group")) {
			if (typeof this.notifItem.members === "object") {
				try {
					this.groupUsers = await getUsers(this.notifItem.members);
				} catch (error) {
					console.log(error);
				}
			}

			if (
				this.notifItem.type === "group-created" ||
				this.notifItem.type === "groups" ||
				this.notifItem.type === "group-admin-change"
			) {
				if (this.notifItem.group) {
					try {
						this.group = await getGroup(this.notifItem.group);
						this.group.membersData = await getUsers(this.group.members);

						if (typeof this.notifItem.members === "string") {
							this.groupUsers = this.group.membersData;
						}

						const authUser = this.$store.state.user.authUser.uid;
						if (this.group.members.includes(authUser)) {
							this.userIsInGroup = true;
						} else {
							this.userIsInGroup = false;
						}
					} catch (error) {
						console.log(error);
					}
				}
			}
		}

		try {
			this.user = await getUser(this.notifItem.user);
		} catch (error) {
			console.log(error);
		}
	},
	methods: {
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			html.style.overflowY = "scroll";

			if (modalContainer !== null) {
				modalContainer.removeEventListener("click", this.closeModal);
			} else {
				const notifSubMenu = window.document.querySelector(
					".notifications-sub-menu"
				);
				notifSubMenu.style.display = "none";
			}

			this.$store.commit("updateNotificationsModal", false);
		},
		goToUser() {
			this.closeModal();
			this.$router.push({ path: `/s/${this.user.username}` });
		},
		goToAbout() {
			this.closeModal();
			this.$router.push({ path: `/about` });
		},
		markAsRead() {
			const authUser = this.$store.state.user.authUser.uid;
			this.removeFromUserNotifications(authUser, this.notifItem.id);
		},
		openGroupsModal() {
			this.closeModal();

			const html = document.querySelector("html");
			const app = document.querySelector("#app");
			app.classList.add("blur-app");
			html.style.overflowY = "hidden";

			if (this.$store.state.user.authUser.emailVerified) {
				//Set payload
				let payload = {
					show: true,
					from: "groups",
					group: this.group
				};

				//Set state
				this.$store.commit("updateGroupsModal", payload);
			} else {
				//Show account modal
				let payload = {
					show: true,
					action: "verify-email"
				};

				this.$store.commit("updateAccountModal", payload);
			}
		},
		showAllGroups() {
			this.closeModal();
			this.showGroupsModal();
		}
	}
};
</script>

<style scoped>
li {
	padding: 10px 0px;
	display: flex;
	width: 100%;
	align-items: center;
	cursor: pointer;
	transition: 0.3s all ease;
}

li:hover {
	background-color: #1a1a1a;
	box-shadow: rgba(15, 15, 15, 0.05) 0px 0px 0px 1px,
		rgba(15, 15, 15, 0.1) 0px 5px 10px, rgba(15, 15, 15, 0.2) 0px 15px 40px;
}

li:last-of-type:hover {
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
}

li:not(:first-of-type) {
	border-top: 1px solid #1a1a1a;
}

li > div:first-of-type {
	width: 8%;
	margin-left: 20px;
}

li > div:first-of-type ion-icon[name="radio-button-off"]:hover {
	color: #51c715;
}

.activity-item .notif-body,
.unlock-item .notif-body {
	width: 50%;
}

.activity-item .notif-action,
.unlock-item .notif-action {
	width: 28%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.groups-item .notif-body {
	width: 80%;
}

.groups-item div:last-of-type {
	width: 10%;
	text-align: center;
}

.notif-title {
	font-size: 13px;
	color: #fff;
}

.notif-date,
.notif-message {
	font-size: 11px;
	color: #b7b7b7;
}

.notif-message {
	display: flex;
	align-items: center;
}

.notif-user {
	font-size: 11px;
}

.notif-details {
	line-height: 0.8;
}

.notif-profile-picture {
	width: 10%;
	display: flex;
	font-size: 30px;
	margin-right: 2px;
}

.notif-profile-picture img {
	height: 35px;
	width: 35px;
	border-radius: 50%;
	object-fit: cover;
	cursor: pointer;
}

.group-count {
	vertical-align: top;
	font-size: 10px;
	margin-top: 3px;
	padding-left: 5px;
}

.group-name {
	border: 1px solid #51c715;
	color: #51c715;
	font-size: 11px;
	border-radius: 25px;
	height: fit-content;
	border-radius: 25px;
	padding: 1px 7px;
	margin-top: 5px;
}

a {
	color: #51c715;
}

ion-icon[name="radio-button-off"] {
	transition: 0.3s ease all;
	cursor: pointer;
	color: #555;
}

ion-icon[name="arrow-round-forward"] {
	vertical-align: middle;
	font-size: 17px;
	color: #51c715;
}

ion-icon[name="logo-buffer"],
ion-icon[name="ios-contacts"] {
	vertical-align: middle;
	font-size: 35px;
	color: #51c715;
}

@media only screen and (max-width: 500px) {
	.notif-profile-picture img {
		height: 30px;
		width: 30px;
	}

	.activity-item .notif-body {
		width: 50%;
	}

	ion-icon[name="logo-buffer"],
	ion-icon[name="ios-contacts"] {
		font-size: 30px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/NotificationsListItem.vue